import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer style={{
      backgroundColor: '#1f2937',
      color: '#f3f4f6',
      padding: '3rem 2rem 2rem',
      marginTop: 'auto'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '2rem'
      }}>
        {/* Company Info */}
        <div>
          <img 
            src="https://customer-assets.emergentagent.com/job_returnpal-pickup/artifacts/x8ux114u_Screenshot%202026-04-27%20165324.png" 
            alt="ReturnPal" 
            style={{ height: '70px', width: 'auto', marginBottom: '1rem' }}
          />
          <p style={{ fontSize: '0.875rem', color: '#d1d5db', lineHeight: '1.6' }}>
            Making returns easy, convenient, and stress-free since 2026.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1rem' }}>Quick Links</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <span 
                onClick={() => navigate('/')} 
                style={{ color: '#d1d5db', cursor: 'pointer', fontSize: '0.875rem' }}
                onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Home
              </span>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <span 
                onClick={() => navigate('/signup')} 
                style={{ color: '#d1d5db', cursor: 'pointer', fontSize: '0.875rem' }}
                onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Schedule Pickup
              </span>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <span 
                onClick={() => navigate('/login')} 
                style={{ color: '#d1d5db', cursor: 'pointer', fontSize: '0.875rem' }}
                onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Customer Login
              </span>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1rem' }}>Legal</h3>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            <li style={{ marginBottom: '0.5rem' }}>
              <span 
                onClick={() => navigate('/terms')} 
                style={{ color: '#d1d5db', cursor: 'pointer', fontSize: '0.875rem' }}
                onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Terms of Service
              </span>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <span 
                onClick={() => navigate('/privacy')} 
                style={{ color: '#d1d5db', cursor: 'pointer', fontSize: '0.875rem' }}
                onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Privacy Policy
              </span>
            </li>
            <li style={{ marginBottom: '0.5rem' }}>
              <span 
                onClick={() => navigate('/cancellation')} 
                style={{ color: '#d1d5db', cursor: 'pointer', fontSize: '0.875rem' }}
                onMouseEnter={(e) => e.target.style.color = '#3b82f6'}
                onMouseLeave={(e) => e.target.style.color = '#d1d5db'}
              >
                Cancellation Policy
              </span>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', marginBottom: '1rem' }}>Contact</h3>
          <p style={{ fontSize: '0.875rem', color: '#d1d5db', marginBottom: '0.5rem' }}>
            Email: support@getreturnpal.com
          </p>
          <p style={{ fontSize: '0.875rem', color: '#d1d5db' }}>
            Hours: Mon-Fri, 9AM-6PM
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div style={{
        maxWidth: '1200px',
        margin: '2rem auto 0',
        paddingTop: '2rem',
        borderTop: '1px solid #374151',
        textAlign: 'center',
        fontSize: '0.875rem',
        color: '#9ca3af'
      }}>
        <p>© {new Date().getFullYear()} ReturnPal. All rights reserved. Governed by the laws of the State of Arizona.</p>
      </div>
    </footer>
  );
};

export default Footer;
